import { Injectable } from '@angular/core';
import { BaseSignalStore } from '@core/state/base-store';
import { NotaryDto } from '@shared/models/dto/api-dtos';

/**
 * State interface for Notaries store
 */
export interface NotariesState {
  notaries: NotaryDto[];
  filters: {
    notaryOfficeId?: number;
    actif?: boolean | null;
    search?: string;
  };
}

/**
 * Store for managing Notaries state
 * Handles data, loading, error states, and filtering
 */
@Injectable({ providedIn: 'root' })
export class NotariesStore extends BaseSignalStore<NotariesState> {
  constructor() {
    super({
      notaries: [],
      filters: {}
    });
  }

  // Computed selectors
  readonly notaries = this.select(state => state.notaries);
  readonly filters = this.select(state => state.filters);
  readonly isEmpty = this.select(state => state.notaries.length === 0);

  // Observable selectors for RxJS integration
  readonly notaries$ = this.select$(state => state.notaries);
  readonly filters$ = this.select$(state => state.filters);
  readonly isEmpty$ = this.select$(state => state.notaries.length === 0);

  /**
   * Sets the notaries data
   */
  setNotaries(notaries: NotaryDto[]): void {
    this.setState({
      notaries
    });
  }

  /**
   * Updates the filters
   */
  setFilters(filters: Partial<NotariesState['filters']>): void {
    this.setState({
      filters: { ...this.state().filters, ...filters }
    });
  }

  /**
   * Clears all filters
   */
  clearFilters(): void {
    this.setState({
      filters: {}
    });
  }

  /**
   * Resets the store to initial state
   */
  override reset(): void {
    super.reset();
  }
}

